<script>
	import environment from '$lib/environment'
	import { HELP_URL, PRIVACY_URL, TERMS_URL } from '$lib/urls'

	const links = [
		{ name: 'Dashboard', path: '/' },
		{ name: 'Support', path: HELP_URL },
		{ name: 'Settings', path: '/settings' },
		{ name: 'Privacy', path: PRIVACY_URL },
		{ name: 'Terms', path: TERMS_URL }
	]
</script>

<div class="footer p-4 flex flex-col justify-center items-center md:hidden">
	<div class="p-4 text-gray-50 flex flex-wrap justify-center">
		{#each links as link}
			<a class="underline whitespace-nowrap px-4 py-2" href={link.path}>
				{link.name}
			</a>
		{/each}
	</div>

	<div class="p-4 text-gray-100">© Invoicer.ai {environment.copyrightYear}</div>
</div>

<style>
	.footer {
		background: rgba(0, 0, 0, 0.7);
	}
</style>
